/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import type { TGetState } from '../../../core/tivo/tivo-redux-wrapper';
import {
    onLeftSetPreviousPage,
    onRightGuideOperations,
    onRightSetNextPage,
    turnOffPastGuideMode,
} from '../guide.reducers';
import { setHorizontalPosition } from '../guidehighlight/guidehighlight.reducers';

export const onRightPastGuideOperations = () => (dispatch: Function, getState: TGetState) => {
    const { horizontalPosition, horizontalPageCount } = getState().guideHighlight;
    const { isPastGuideMode } = getState().gridGuide;

    const isFirstPastGuidePage = isPastGuideMode && Math.abs(horizontalPageCount) === 1;

    if (horizontalPosition === 0 && isFirstPastGuidePage) {
        dispatch(turnOffPastGuideMode());
        dispatch(onRightSetNextPage());
    } else {
        dispatch(onRightGuideOperations());
    }
};

export const onLeftPastGuideOperations = () => (dispatch: Function, getState: TGetState) => {
    const { guideHighlight, gridGuide } = getState();
    const { guideRows } = gridGuide;
    const { horizontalPosition, horizontalPageCount, verticalPosition } = guideHighlight;

    let _horizontalPosition = horizontalPosition - 1;
    const hasGuideRow = guideRows && guideRows[verticalPosition];
    if (hasGuideRow && Math.abs(horizontalPageCount) === 1 && horizontalPosition === 0) {
        const { guideCells } = guideRows[verticalPosition];
        _horizontalPosition = guideCells.length;
        dispatch(setHorizontalPosition(_horizontalPosition));
    } else if (_horizontalPosition > 0) {
        dispatch(setHorizontalPosition(_horizontalPosition));
    } else {
        dispatch(onLeftSetPreviousPage());
    }
};
